<script lang="ts">
  import { MessageSquareText, History } from "lucide-svelte";
  interface Props {
    type: 'today' | 'yesterday';
    todayInquiries?: number;
    yesterdayInquiries?: number;
    totalInquiries?: number;
    t: (path: string, params?: Record<string, any>) => string;
  }
  let { type, todayInquiries = 0, yesterdayInquiries = 0, totalInquiries = 0, t }: Props = $props();
</script>

{#if type === 'today'}
  <div class="rounded-xl border bg-card p-4 shadow-sm flex flex-col justify-between">
    <div class="flex items-center justify-between">
      <p class="text-xs font-medium text-muted-foreground uppercase tracking-wider">{t('dashboard.kpi.today_inquiries')}</p>
      <MessageSquareText class="h-4 w-4 text-primary" />
    </div>
    <div class="mt-2 flex items-baseline gap-2">
      <span class="text-3xl font-extrabold tracking-tight">{todayInquiries}</span>
      <span class="text-xs text-muted-foreground">{t('dashboard.kpi.inquiry_unit')}</span>
    </div>
    <div class="mt-3 flex items-center justify-between text-xs text-muted-foreground border-t pt-2">
      <span>{t('dashboard.kpi.total_captured')} <strong class="text-foreground">{totalInquiries}</strong></span>
      <span class="text-primary font-medium">{t('dashboard.kpi.instant_receive')}</span>
    </div>
  </div>
{:else}
  <div class="rounded-xl border bg-card p-4 shadow-sm flex flex-col justify-between bg-muted/20">
    <div class="flex items-center justify-between">
      <p class="text-xs font-medium text-muted-foreground uppercase tracking-wider">{t('dashboard.kpi.yesterday_inquiries')}</p>
      <History class="h-4 w-4 text-muted-foreground" />
    </div>
    <div class="mt-2 flex items-baseline gap-2">
      <span class="text-3xl font-extrabold tracking-tight">{yesterdayInquiries}</span>
      <span class="text-xs text-muted-foreground">{t('dashboard.kpi.inquiry_unit')}</span>
    </div>
    <div class="mt-3 flex items-center justify-between text-xs text-muted-foreground border-t pt-2">
      <span>{t('dashboard.kpi.yesterday_archived_inquiries')}</span>
      <span>{t('dashboard.kpi.in_database')}</span>
    </div>
  </div>
{/if}